// frontend/src/components/Common/PdfViewerModal.js
//
// Shared inline PDF preview — an <iframe> in a modal, used by both the
// student AskOS PYQ Practice page and the Samkalp Admin PYQ Bank tab.
// Requires the presigned URL's Content-Type/Content-Disposition to
// actually be application/pdf + inline (see pyq_router.py's
// _presigned_pdf_url) — without that, browsers download instead of
// rendering, regardless of how the link is opened client-side.
import React from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';

const PdfViewerModal = ({ show, onHide, url, title, onDownload }) => (
    <Modal show={show} onHide={onHide} size="xl" centered>
        <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: 16 }}>{title || 'PDF Preview'}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: 0, height: '80vh', background: '#525659' }}>
            {url ? (
                <iframe title={title || 'PDF preview'} src={url} style={{ width: '100%', height: '100%', border: 'none' }} />
            ) : (
                <div className="d-flex align-items-center justify-content-center h-100 text-white-50">
                    <Spinner animation="border" size="sm" className="me-2" /> Loading…
                </div>
            )}
        </Modal.Body>
        <Modal.Footer>
            {onDownload && <Button variant="outline-primary" size="sm" onClick={onDownload}>⬇ Download</Button>}
            <Button variant="secondary" size="sm" onClick={onHide}>Close</Button>
        </Modal.Footer>
    </Modal>
);

export default PdfViewerModal;
